import { useState, useEffect, useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import {
  auth,
  createUserWithEmailAndPassword,
} from "../utils/firebase";

import "./JobBankSignup.css";

import {
  doc,
  getDoc,
  setDoc,
  updateDoc,
  serverTimestamp
} from "firebase/firestore";

import { db } from "../utils/firebase";

import {
  getAuth,
  PhoneAuthProvider,
  RecaptchaVerifier,
  multiFactor,
  sendEmailVerification,
  onAuthStateChanged,
  GoogleAuthProvider,
  signInWithPopup,
} from "firebase/auth";

import { TokenContext } from "./tokenContext"; // import TokenContext
import { logout } from "../utils/firebase";
import { createPortal } from "react-dom";
import GlobalNavDrawer from "./GlobalNavDrawer";
import { useAuth } from './AuthContext';
import {
  previewOffer,
  redeemOffer
} from "../utils/offersClient";

import googleLogo from "./GoogleG.png";

function JobBankSignup() {
  const { balance, setBalance } = useContext(TokenContext);
    const { currentUser } = useAuth();
    useEffect(() => {
            let isMounted = true;
        
            const fetchTokens = async () => {
            if (!currentUser?.uid) return;
        
            const userRef = doc(db, "users", currentUser.uid);
        
            try {
                const userDoc = await getDoc(userRef);
        
                if (userDoc.exists() && isMounted) {
                setBalance(userDoc.data().tokens ?? 0);
                }
            } catch (error) {
                console.error("Error fetching token count:", error);
            }
            };
        
            fetchTokens();
        
            return () => {
            isMounted = false;
            };
        }, [currentUser, setBalance]);
  const [email, setEmail] =
    useState("");

  const [password, setPassword] =
    useState("");

  const [confirmPassword, setConfirmPassword] =
    useState("");

  const [firstName, setFirstName] =
    useState("");

  const [lastName, setLastName] =
    useState("");

  const [phone, setPhone] =
    useState("");

  const [smsCode, setSmsCode] =
    useState("");

  const [verificationId, setVerificationId] =
    useState(null);

  const [error, setError] =
    useState("");

  const [message, setMessage] =
    useState("");

  const [showPassword, setShowPassword] =
    useState(false);

  const [awaitingVerification, setAwaitingVerification] =
    useState(false);

  const navigate = useNavigate();

  const defaultUserFields = {

    role: "user",

    jobBankRole: "Job Seeker",

    userType: "token",

    tokens: 2,

    desiredPurchase: 0,

    paying: false,

    emailVerified: false,

    mfaEnrolled: false,

    awaitingVerification: false,

    username: "",

    phone: "",

    createdAt: serverTimestamp()

  };

  function initRecaptcha() {

    if (!window.recaptchaVerifier) {

      window.recaptchaVerifier =
        new RecaptchaVerifier(
          auth,
          "recaptcha-container",
          {
            size: "invisible"
          }
        );
    }
  }

  function normalizePhone(input) {

    if (!input) return "";

    let digits =
      input.replace(/[^\d+]/g, "");

    if (/^1\d{10}$/.test(digits)) {

      return "+" + digits;

    }

    if (digits.startsWith("+")) {

      return digits;

    }

    if (/^\d{10}$/.test(digits)) {

      return "+1" + digits;

    }

    return digits;
  }

  async function tryRedeemSignupOffer() {

    const authInstance =
      getAuth();

    const user =
      authInstance.currentUser;

    if (!user) return;

    const idToken =
      await user.getIdToken();

    const baseUrl =
      process.env.REACT_APP_FLUENCY_SERVER;

    const url =
      new URL(window.location.href);

    const coupon =
      url.searchParams.get("coupon") ||
      url.searchParams.get("code") ||
      "";

    const utm = {

      source:
        url.searchParams.get("utm_source") ||
        null,

      medium:
        url.searchParams.get("utm_medium") ||
        null,

      campaign:
        url.searchParams.get("utm_campaign") ||
        null

    };

    const pv =
      await previewOffer(
        idToken,
        baseUrl,
        {
          coupon,
          utm
        }
      );

    const selectedOfferId =
      pv?.offer?.id || null;

    await redeemOffer(
      idToken,
      baseUrl,
      {
        offerId:
          selectedOfferId,

        coupon,

        utm
      }
    );
  }

  const isStrongPassword = (password) =>
    /^(?=.*[A-Z])(?=.*\d).{8,}$/.test(password);

  const handleSignup = async (event) => {

    event.preventDefault();

    setError("");

    setMessage("");

    if (password !== confirmPassword) {

      setError(
        "Passwords do not match."
      );

      return;
    }

    if (!isStrongPassword(password)) {

      setError(
        "Password should be at least 8 characters, contain a number and an uppercase letter."
      );

      return;
    }

    if (!phone) {

      setError(
        "Phone number is required for verification."
      );

      return;
    }

    if (!/^\+\d{10,15}$/.test(phone)) {

      setError(
        "Invalid phone format. Use +15555555555"
      );

      return;
    }

    try {

      const userCredential =
        await createUserWithEmailAndPassword(
          auth,
          email,
          password
        );

      const user =
        userCredential.user;

      const actionCodeSettings = {

        url:
          "https://ispeakwell.ca/jobbank/login",

        handleCodeInApp:
          false

      };

      await sendEmailVerification(
        user,
        actionCodeSettings
      );

      await setDoc(
        doc(
          db,
          "users",
          user.uid
        ),
        {
          ...defaultUserFields,

          email,

          firstName,

          lastName,

          phone,

          emailVerified:
            false,

          awaitingVerification:
            true
        }
      );

      setMessage(
        "Account created successfully. Please verify your email before continuing."
      );

      setAwaitingVerification(
        true
      );

    } catch (err) {

      console.error(
        "Error signing up:",
        err
      );

      setError(
        err.message
      );
    }
  };

  const handleGoogleSignup = async () => {

    const provider =
      new GoogleAuthProvider();

    try {

      const result =
        await signInWithPopup(
          auth,
          provider
        );

      const user =
        result.user;

      const [
        firstName,
        lastName = ""
      ] =
        user.displayName
          ? user.displayName.split(" ")
          : ["", ""];

      const userRef =
        doc(
          db,
          "users",
          user.uid
        );

      await setDoc(
        userRef,
        {
          ...defaultUserFields,

          email:
            user.email,

          firstName,

          lastName,

          emailVerified:
            user.emailVerified ?? false,

          phone: "",

          awaitingVerification:
            true
        },
        {
          merge: true
        }
      );

      await tryRedeemSignupOffer();

      navigate("/jobbank");

    } catch (err) {

      console.error(
        "Google sign-up error:",
        err
      );

      setError(
        "Error signing up with Google."
      );
    }
  };

  useEffect(() => {

    const unsubscribe =
      onAuthStateChanged(
        auth,
        async (user) => {

          if (
            user &&
            user.emailVerified &&
            awaitingVerification
          ) {

            try {

              await updateDoc(
                doc(
                  db,
                  "users",
                  user.uid
                ),
                {
                  emailVerified: true,
                  awaitingVerification: false
                }
              );

              initRecaptcha();

              const provider =
                new PhoneAuthProvider(
                  auth
                );

              const verificationId =
                await provider.verifyPhoneNumber(
                  phone,
                  window.recaptchaVerifier
                );

              setVerificationId(
                verificationId
              );

              setMessage(
                "A verification code was sent to your phone."
              );

            } catch (err) {

              setError(
                "Error verifying phone number: " +
                err.message
              );
            }
          }
        }
      );

    return () =>
      unsubscribe();

  }, [
    awaitingVerification,
    phone
  ]);

  const handleVerifyCode = async () => {

    if (
      !verificationId ||
      !smsCode
    ) {

      setError(
        "Enter the code you received."
      );

      return;
    }

    try {

      const cred =
        PhoneAuthProvider.credential(
          verificationId,
          smsCode
        );

      const mfaUser =
        multiFactor(
          auth.currentUser
        );

      await mfaUser.enroll(
        cred,
        "phone number"
      );

      await setDoc(
        doc(
          db,
          "users",
          auth.currentUser.uid
        ),
        {
          mfaEnrolled: true
        },
        {
          merge: true
        }
      );

      await tryRedeemSignupOffer();

      navigate("/jobbank");

    } catch (err) {

      console.error(
        "Error verifying code:",
        err
      );

      setError(
        err.message
      );
    }
  };

  return (

    <div className="JBS-container">

      <div className="JBS-card">

        <h1 className="JBS-title">
          Community Job Bank
        </h1>

        <p className="JBS-subtitle">
          Create Your Account
        </p>

        <p className="JBS-description">
          Connect with employers, hiring events,
          career coaches, and local opportunities.
        </p>

        <form
          className="JBS-form"
          onSubmit={handleSignup}
        >

          <input
            type="text"
            placeholder="First Name"
            value={firstName}
            onChange={(e) =>
              setFirstName(
                e.target.value
              )
            }
          />

          <input
            type="text"
            placeholder="Last Name"
            value={lastName}
            onChange={(e) =>
              setLastName(
                e.target.value
              )
            }
          />

          <input
            type="email"
            placeholder="Email Address"
            value={email}
            onChange={(e) =>
              setEmail(
                e.target.value
              )
            }
          />

          <input
            type={
              showPassword
                ? "text"
                : "password"
            }
            placeholder="Password"
            value={password}
            onChange={(e) =>
              setPassword(
                e.target.value
              )
            }
          />

          <input
            type={
              showPassword
                ? "text"
                : "password"
            }
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={(e) =>
              setConfirmPassword(
                e.target.value
              )
            }
          />

          <input
            type="tel"
            placeholder="+15555555555"
            value={phone}
            onChange={(e) =>
              setPhone(
                normalizePhone(
                  e.target.value
                )
              )
            }
          />

          <button
            type="button"
            className="JBS-button"
            onClick={() =>
              setShowPassword(
                !showPassword
              )
            }
          >
            {showPassword
              ? "Hide"
              : "Show"} Password
          </button>

          <button
            type="submit"
            className="JBS-button"
          >
            Create Account
          </button>

        </form>

        <button
          className="JBS-google-btn"
          onClick={handleGoogleSignup}
        >
          <img
            src={googleLogo}
            alt="Google"
            style={{
              width: "20px",
              marginRight: "10px"
            }}
          />
          Continue with Google
        </button>

        {verificationId && (

          <div
            className="JBS-form"
            style={{
              marginTop: "20px"
            }}
          >

            <input
              type="text"
              placeholder="123456"
              value={smsCode}
              onChange={(e) =>
                setSmsCode(
                  e.target.value
                )
              }
            />

            <button
              className="JBS-button"
              onClick={
                handleVerifyCode
              }
            >
              Verify & Continue
            </button>

          </div>

        )}

        {error && (
          <div className="JBS-error">
            {error}
          </div>
        )}

        {message && (
          <div className="JBS-message">
            {message}
          </div>
        )}

        <div className="JBS-links">

          <Link to="/jobbank/login" className="JBS-login-link"> 
            Already have an account?
          </Link>

        </div>

      </div>

      <div id="recaptcha-container"></div>
      {createPortal(
              <GlobalNavDrawer
                hideCurrent
                links={[
                  { to: "/purchase", label: `Tokens: ${balance}`},
                  { to: "/jobbank", label: "Job Bank Home"},
                  { to: "/voicebot", label: "iSpeakWell" },
                  { to: "/resumerevisor", label: "Resumes" },
                  { to: "/conversationpractice", label: "Convos" },
                  { to: "/interview-practice", label: "Interviews" },
                  { to: "/termsofservice", label: "Terms" },
                  { to: "/privacypolicy", label: "Privacy" },
                  { to: "/admin", label: "Admin" },
                  { to: "/login", label: "Logout", onClick: async () => { await logout(); } },
                ]}
              />,
                document.body
            )}
    </div>

  );
}

export default JobBankSignup;